<!--
 * @Author: your name
 * @Description: 标准库管理
-->
<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <div id="standardList" v-loading="showPageLoading" class="h-full">
      <!-- 筛选条件 -->
      <div class="h-36px">
        <el-row class="h-36px">
          <el-col :span="12" class="flex">
            <el-form :inline="true" style="display: flex">
              <el-form-item>
                <el-input
                  @keyup.enter.native="getList()"
                  v-model.trim="keyword"
                  :placeholder="`${$t('pleaseEnterStandradNameOrCode')}`"
                  clearable
                  size="small"
                ></el-input>
              </el-form-item>
            </el-form>
            <el-button type="primary" size="small" @click="getList">{{ $t('search') }}</el-button>
            <el-button
              v-if="displayType === 'list' && $hasAccess('create')"
              class="ml-10px"
              type="primary"
              size="small"
              @click="addsShowStandard"
              >{{ $t('create') }}</el-button
            >
          </el-col>
          <div class="float-right">
            <i
              v-if="displayType === 'card'"
              :title="$t('listPresentation')"
              class="el-icon-s-operation text-24px font-bold cursor-pointer"
              @click="changeDisplayType('list')"
            ></i>
            <i
              v-else
              :title="$t('cardDisplay')"
              class="el-icon-menu text-24px cursor-pointer"
              @click="changeDisplayType('card')"
            ></i>
          </div>
        </el-row>
      </div>
      <!-- 卡片展示 -->
      <div
        v-if="displayType === 'card'"
        class="standardList w-full"
        id="standardListBox"
        @mouseover="enterOther($event)"
        style="height: calc(100% - 56px); overflow: auto"
      >
        <el-col shadow="always" class="mb-20px mr-20px w-250px h-280px" v-if="$hasAccess('create')">
          <el-card class="custom-card w-full h-full relative">
            <div class="add" @click="addsShowStandard">
              <i class="el-icon-plus"></i>
              <p>{{ $t('createNewStandardDatabase') }}</p>
            </div>
          </el-card>
        </el-col>
        <el-col
          class="mb-20px mr-18px w-250px h-280px"
          v-for="(value, index) in modelList"
          :key="index"
          shadow="always"
        >
          <el-card
            style="position: relative"
            @mouseenter.native.stop="enter(index, $event)"
            :body-style="{ height: '100%' }"
            class="custom-card w-full h-full"
          >
            <div class="status" v-if="!value.add"></div>
            <p class="statusName" v-if="!value.add">
              {{ $t(value.approveStatus === 0 ? 'working' : 'released') }}
            </p>
            <div v-if="!value.add" class="w-full text-center h-212px">
              <img
                v-if="value.thumbnail"
                class="h-full inline-block"
                :src="value.thumbnail"
                alt
                @click="toModelDetail(value)"
              />
              <img
                v-if="!value.thumbnail"
                class="h-full inline-block"
                src="../../../../../public/images/standard.jpg"
                alt
                @click="toModelDetail(value)"
              />
            </div>
            <el-divider class="!my-0px !h-6px !bg-[#35b3fe]"></el-divider>
            <div v-if="!value.add" class="action-header pl-14px pr-14px pt-5px pb-5px">
              <p
                class="w-full mt-5px action-title ell text-16px c-white truncate text-center"
                :title="value.name"
              >
                {{ value.name }}
              </p>
              <p class="w-full text-center text-12px mt-10px truncate">{{ value.code }}</p>
            </div>
            <!-- 鼠标悬浮状态 -->
            <div
              class="hoverDiv h-full w-full flex"
              id="hoverDivBox"
              v-if="ishover && hoverIndex === index"
            >
              <!-- <div
                id="hoverDivItem"
                class="flex"
                :class="activeNum === 1 ? 'active' : ''"
                @mouseenter.stop="hoverDivItemEnter(1)"
                @click="goDrawList(value.id)"
              >
                <el-tooltip content="跳转至模型管理" id="hoverDivBtn" placement="top">
                  <el-button
                    class="ml-0px el-icon-s-grid btnStyle"
                    :class="activeNum === 1 ? 'activeBtn' : ''"
                    type="primary"
                  ></el-button>
                </el-tooltip>
              </div> -->
              <div
                id="hoverDivItem"
                class="flex"
                :class="activeNum === 2 ? 'active' : ''"
                @mouseenter.stop="hoverDivItemEnter(2)"
                @click="goClassList(value.id)"
              >
                <el-tooltip :content="$t('gotoEntityManagement')" id="hoverDivBtn" placement="top">
                  <el-button
                    class="ml-0px el-icon-s-data btnStyle"
                    :class="activeNum === 2 ? 'activeBtn' : ''"
                    type="primary"
                  ></el-button>
                </el-tooltip>
              </div>
              <div
                id="hoverDivItem"
                class="flex"
                :class="activeNum === 3 ? 'active' : ''"
                @mouseenter.stop="hoverDivItemEnter(3)"
              >
                <el-dropdown>
                  <span class="el-dropdown-link">
                    <el-tooltip :content="$t('more')" id="hoverDivBtn" placement="top">
                      <el-button
                        class="ml-0px el-icon-more btnStyle"
                        :class="activeNum === 3 ? 'activeBtn' : ''"
                        type="primary"
                      ></el-button>
                    </el-tooltip>
                  </span>
                  <el-dropdown-menu slot="dropdown" @mouseleave.native="leave()">
                    <el-dropdown-item
                      command="edit"
                      @click.native="handleModifyModel(value.id)"
                      v-if="$hasAccess('update')"
                    >
                      {{ $t('edit') }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="deleteModel(value.id)"
                      command="delete"
                      v-if="$hasAccess('delete')"
                    >
                      {{ $t('delete') }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="exportFile(value.id)"
                      v-if="$hasAccess('export')"
                      command="exportXls"
                    >
                      {{ $t('export') }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      size="small"
                      class="iconfont"
                      @click.native="importFile(value)"
                      v-if="$hasAccess('import')"
                      type="success"
                    >
                      {{ $t('import') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </el-card>
        </el-col>
      </div>
      <!-- 列表展示 -->
      <div v-if="displayType === 'list'" class="w-full h-full">
        <el-table
          :data="modelList"
          v-loading="showPageLoading"
          class="mt-20px"
          height="calc(100% - 60px)"
          :highlight-current-row="true"
          ref="table"
          row-key="id"
          stripe
          border
        >
          <el-table-column type="index" :label="$t('序号')" width="55"></el-table-column>
          <el-table-column
            :label="$t('standardCode')"
            prop="code"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="$t('standardName')"
            prop="name"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="$t('version')"
            prop="revision"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="$t('state')" prop="approveStatus" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ $t(scope.row.approveStatus === 0 ? 'working' : 'released') }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('remarks')"
            prop="remark"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="$t('createdTime')"
            prop="createdTime"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="$t('CreateUser')"
            prop="createdUserName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="$t('LastModified')"
            prop="lastModifiedTime"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="$t('LastModifiedUser')"
            prop="lastModifiedUserName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="$t('operate')" fixed="right" width="240">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleModifyModel(scope.row.id)">{{
                $t('edit')
              }}</el-button>
              <el-button size="mini" @click="deleteModel(scope.row.id)">{{
                $t('delete')
              }}</el-button>
              <el-button size="mini" @click="goClassList(scope.row.id)">{{
                $t('Class')
              }}</el-button>
              <!-- <el-button size="mini" @click="goDrawList(scope.row.id)">绘图</el-button> -->
              <el-dropdown trigger="click" class="ml-10px" size="mini">
                <el-button size="mini">
                  {{ $t('more') }}<i class="iconfont icon-app-next text-12px"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="exportFile(scope.row)">{{
                    $t('export')
                  }}</el-dropdown-item>
                  <el-dropdown-item @click.native="importFile(scope.row)">{{
                    $t('import')
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 新增标准的弹窗 -->
      <el-dialog
        :title="$t(title)"
        :visible.sync="modelDialogVisible"
        :close-on-click-modal="false"
        :lock-scroll="true"
        v-dialogDrag
        class="small-dialog"
      >
        <div>
          <el-form
            label-width="150px"
            ref="standardModel"
            :rules="currentLang === 'zh-Hans' ? rules : enRules"
            :model="standardModel"
          >
            <el-form-item :label="`${$t('thumbnail')}:`" prop="thumbnail">
              <el-upload
                class="avatar-uploader h-180px"
                action="#"
                :show-file-list="false"
                :on-progress="onProgress"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="standardModel.thumbnail" :src="standardModel.thumbnail" class="avatar" />
                <div v-else>
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <p class="w-full absolute text-center bottom-36px text-12px text-[#8c939d]">
                    {{ $t('TheRecommendedSizeIs220Pixels') }}
                  </p>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="模板标准:" prop="templateId">
              <el-select
                :disabled="title !== $t('createStandard')"
                filterable
                clearable
                class="width-385px"
                v-model="standardModel.templateId"
                @change="changeStandardTemplate"
              >
                <el-option
                  v-for="item in standardTemplateList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-button
                v-if="$hasAccess('import')"
                class="ml-10px"
                size="small"
                type="primary"
                @click="importStandardTemplate"
                >导入</el-button
              >
              <el-button v-if="$hasAccess('export')" @click="exportTemplateDetail" type="success"
                >导出</el-button
              >
            </el-form-item>
            <el-form-item :label="`${$t('code')}:`" prop="code">
              <el-input
                class="width-385px"
                v-model="standardModel.code"
                maxlength="25"
                :readonly="title === $t('editTheStandard')"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('name')}:`" prop="name">
              <el-input class="width-385px" v-model="standardModel.name"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('version')}:`" prop="revision">
              <el-input class="width-385px" v-model="standardModel.revision"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('seqNo')}:`" prop="seqNo">
              <el-input-number
                class="width-385px"
                v-model="standardModel.seqNo"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item :label="`${$t('status')}:`" prop="approveStatus">
              <el-select
                class="width-385px"
                v-model.number="standardModel.approveStatus"
                :placeholder="$t('pleaseSelect')"
              >
                <el-option
                  v-for="item in approveStatusList"
                  :key="item.id"
                  :label="$t(item.name)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('remarks')}:`" prop="remark">
              <el-input
                class="width-385px"
                type="textarea"
                v-model="standardModel.remark"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer tc">
          <el-button
            size="small"
            type="primary"
            :loading="saveLoading"
            @click="handleAddTagObject('standardModel')"
            >{{ $t('save') }}</el-button
          >
          <el-button size="small" @click="closeDialog('standardModel')">
            {{ $t('cancel') }}
          </el-button>
        </div>
      </el-dialog>

      <wiz-upload-file
        v-dialogDrag
        @refreshList="getList"
        :uploadFileProps="uploadFileProps"
        @exportTemplate="exportTemplate"
        @importTemplate="importTemplate"
      ></wiz-upload-file>
    </div>
    <wiz-upload-file
      v-dialogDrag
      @refreshList="getStdTemplateList()"
      :uploadFileProps="uploadTemplateFileProps"
      @exportTemplate="exportStandardTemplate"
      @importTemplate="importTemplateFile"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import CommonService from '@/services/Common'
import fnMixin from '@/assets/js/fnMixins'

export default {
  mixins: [fnMixin],
  data() {
    return {
      uploadTemplateFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      standardTemplateList: [],
      displayType: 'card', // 列表显示类型，card为卡片显示，list为列表显示
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      saveLoading: false,
      standardId: '',
      ishover: false,
      hoverIndex: null,
      showPageLoading: false,
      keyword: '',
      modelList: [],
      approveStatusList: [
        { id: 0, name: '工作中' },
        { id: 1, name: '已发布' },
      ],
      modelDialogVisible: false,
      standardModel: {
        templateId: '',
        thumbnail: '',
        code: '',
        name: '',
        revision: '',
        approveStatus: 0,
        seqNo: 0,
        remark: '',
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'change' },
          {
            required: true,
            pattern: /^[^?*\[\]".]*$/, // 标准代码不包含? * [ ] " " .字符
            message: '请输入符合规则的代码',
            trigger: 'blur',
          },
        ],
        revision: [{ required: true, message: '请输入版本号', trigger: 'change' }],
      },
      enRules: {
        name: [{ required: true, message: this.$t('pleaseEnterTheName'), trigger: 'change' }],
        code: [
          { required: true, message: this.$t('pleaseEnterTheCode'), trigger: 'change' },
          {
            required: true,
            pattern: /^[^?*\[\]".]*$/, // 标准代码不包含? * [ ] " " .字符
            message: this.$t('onlyLettersNumbersUnderscores'),
            trigger: 'blur',
          },
        ],
        revision: [
          { required: true, message: this.$t('pleaseEnterTheVersion'), trigger: 'change' },
        ],
      },
      title: '',
      contentTitle: 'goToEntityManagement',
      activeNum: '',
      standardList: [],
      importId: '',
    }
  },
  computed: {
    currentLang() {
      return this.$store.getters['System/currentLang']
    },
  },
  watch: {
    modelDialogVisible(val) {
      if (!val) {
        this.clearData()
      }
    },
  },
  async created() {
    this.getList()
    this.getStdTemplateList()
  },
  methods: {
    async exportTemplateDetail() {
      if (!this.standardModel.templateId) {
        this.$message.warning('请选择要导出的模板标注')
        return
      }
      const currentTemplate = _.find(this.standardTemplateList, {
        id: this.standardModel.templateId,
      })
      const res = await StandardManagementService.exportTemplate({
        templateId: this.standardModel.templateId,
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: `${currentTemplate.name}-模板标准.xlsx`,
          data: res,
        })
      }
    },
    changeStandardTemplate(val) {
      if (val) {
        const currentStandardTemplate = _.find(this.standardTemplateList, { id: val })
        this.standardModel.code = currentStandardTemplate.code
        this.standardModel.name = currentStandardTemplate.name
        this.standardModel.revision = currentStandardTemplate.revision
      }
    },
    async importTemplateFile(file) {
      // 上传填写完的标准模板文件
      this.uploadTemplateFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await CommonService.uploadTemplateFile({
        reqUrl: 'std/Common/std-template-upload',
        reqData: formData,
      })
      if (res) {
        this.uploadTemplateFileProps.active = 2
        this.downLoadBlob({
          name: '模板标准导入明细.xlsx',
          data: res,
        })
        this.getStdTemplateList()
      } else if (res.code) {
        this.$message.error(res.msg)
      }
      this.uploadTemplateFileProps.btnLoading = false
    },
    // 导入
    importStandardTemplate() {
      this.uploadTemplateFileProps.visible = true
      this.uploadTemplateFileProps.active = 0
    },
    async exportStandardTemplate() {
      // 下载模板标准导入模板
      const res = await CommonService.downloadTemplateCommon({
        reqUrl: 'std/Common/download-std-template',
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '模板标准导入模板.xlsx',
          data: res,
        })
      }
    },
    async getStdTemplateList() {
      // 获取标准模板列表
      const res = await StandardManagementService.getStdTemplateList()
      if (res.code === 0 && res.data.length) {
        this.standardTemplateList = res.data
      }
    },
    // 切换展示方式
    changeDisplayType(type) {
      this.displayType = type
    },
    // 导入
    importFile(val) {
      this.importId = val.id
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await CommonService.downloadTemplateCommon({
        reqUrl: `std/StdStandard/download_import_template/${this.importId}`,
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '标准导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await CommonService.uploadFile({
        reqUrl: `std/StdStandard/import/${this.importId}`,
        reqData: formData,
      })
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '标准导入明细.xlsx',
          data: res,
        })
        this.getList()
      } else if (res.code) {
        this.$message.error(res.msg)
      }
      this.uploadFileProps.btnLoading = false
    },
    // 导出
    async exportFile(id) {
      const res = await StandardManagementService.exportFile({
        urlParam: '',
        ids: [id],
        downloadType: 0,
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '标准导出结果.xlsx',
          data: res,
        })
      }
    },
    // 获取列表
    async getList() {
      this.standardList = []
      this.modelList = []
      const parameter = {
        keyword: this.keyword,
      }
      this.showPageLoading = true
      const res = await StandardManagementService.getList(parameter)
      this.showPageLoading = false
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.standardList = res.data
        this.modelList = [...this.modelList, ...res.data]
        this.standardModel.seqNo = res.data.length + 1
        const standardId = localStorage.getItem('standardId')
        if (!standardId) {
          localStorage.setItem('standardId', this.standardList[0].id)
          localStorage.setItem('standardCode', this.standardList[0].code)
        }
        if (this.standardList.length > 0) {
          const standardList = []
          _.map(this.standardList, (item) => {
            standardList.push({
              name: item.name,
              code: item.code,
              id: item.id,
            })
          })
          localStorage.setItem('standardList', JSON.stringify(standardList))
        }
      }
    },
    addsShowStandard() {
      this.modelDialogVisible = true
      this.title = this.$t('createStandard')
      this.standardModel.seqNo = this.modelList.length
    },
    // 清除表单数据
    closeDialog() {
      this.modelDialogVisible = false
      this.clearData()
    },
    // 新增以及更新标准
    handleAddTagObject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.title === this.$t('createStandard')) {
            this.$confirm('标准库代码一经创建将不可修改, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.addStandard()
            })
          } else if (this.title === this.$t('editTheStandard')) {
            this.updateStandard()
          } else {
            this.upGradeStandard()
          }
        }
      })
    },
    async handleModifyModel(id) {
      this.modelDialogVisible = true

      this.title = this.$t('editTheStandard')
      // 获取详情
      const res = await StandardManagementService.detail({
        id,
      })
      if (res && res.code === 0 && res.data) {
        this.standardModel = res.data
      }
    },
    // 删除标准
    deleteModel(id) {
      this.$confirm(this.$t('confirmDeleteSelectedStandard'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      }).then(async () => {
        const res = await StandardManagementService.delete([id])
        if (res && res.code === 0 && res.data) {
          await this.getList()
          this.$message({
            message: res.msg,
            type: 'success',
          })
        }
      })
    },
    // 新增
    async addStandard() {
      this.saveLoading = true
      const res = await StandardManagementService.addList({
        model: this.standardModel,
      })
      if (res && res.code === 0) {
        this.clearData()
        this.modelDialogVisible = false
        this.$message({
          message: res.msg,
          type: 'success',
        })
        await this.getList()
      }
      this.saveLoading = false
    },
    async updateStandard() {
      this.saveLoading = true
      const res = await StandardManagementService.upload({
        model: this.standardModel,
      })
      if (res && res.code === 0 && res.data) {
        this.clearData()
        this.modelDialogVisible = false
        this.$message({
          message: res.msg,
          type: 'success',
        })
        await this.getList()
      }
      this.saveLoading = false
    },
    async upGradeStandard() {
      this.saveLoading = true
      const res = await StandardManagementService.upGradeStandard(this.standardModel)
      if (res && res.code === 0) {
        await this.getList()
        this.clearData()
        this.modelDialogVisible = false
        this.$message({
          message: res.msg,
          type: 'success',
        })
      }
      this.saveLoading = false
    },
    async toModelDetail() {
      // this.$router.push({
      //   path: '/StandardManagementService/standardKanban',
      // })
    },
    // 上传图片转化为base64
    onProgress(event, file) {
      const that = this
      const a = new FileReader()
      a.readAsDataURL(file.raw)
      a.onload = () => {
        that.standardModel.thumbnail = a.result
      }
    },
    // 限制上传图片大小以及格式
    beforeAvatarUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg.toLowerCase() === 'jpg'
      const extension2 = testmsg.toLowerCase() === 'png'
      if (!extension && !extension2) {
        this.$message({
          message: this.$t('thumbnailsCanOnlyBeInJpgPng'),
          type: 'warning',
        })
        return false
      }
      if (file.size > 1024 * 15) {
        this.$message.warning('上传图片不能超过15k')
        return
      }

      return isLt2M
    },
    // 置空表单数据
    clearData() {
      this.$refs.standardModel.clearValidate()
      this.$refs.standardModel.resetFields()
      this.standardModel = {
        thumbnail: '',
        code: '',
        name: '',
        revision: '',
        approveStatus: 0,
        seqNo: this.modelList.length,
        remark: '',
      }
    },
    // 跳转至绘图列表
    goDrawList(id) {
      localStorage.setItem('standardId', id)
      this.modelList.forEach((item) => {
        if (item.id === id) {
          localStorage.setItem('standardCode', item.code)
        }
      })
      this.$router.push({
        path: './draw-list',
        query: {
          id,
        },
      })
    },
    goClassList(id) {
      localStorage.setItem('standardId', id)
      this.modelList.forEach((item) => {
        if (item.id === id) {
          localStorage.setItem('standardCode', item.code)
        }
      })
      this.$router.push({
        path: './class-list',
        query: {
          id,
        },
      })
    },
    enter(index) {
      this.ishover = true
      this.hoverIndex = index
    },
    leave() {
      this.ishover = false
      this.hoverIndex = ''
    },
    enterOther(event) {
      if (
        event.fromElement &&
        event.fromElement.id === 'hoverDivItem' &&
        ((event.toElement && event.toElement.id === 'standardListBox') ||
          event.toElement.id === 'standardList')
      ) {
        this.ishover = false
        this.hoverIndex = ''
      }
    },
    hoverDivItemEnter(number) {
      this.activeNum = number
    },
    hoverDivItemLeave() {
      this.activeNum = ''
      this.ishover = false
      this.hoverIndex = ''
    },
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>

/deep/.el-button--success {
  background-color: #67c23a !important;
}
.w-15 {
  width: 15%;
  height: 288px;
}
#standardList {
  background-color: rgba(250, 250, 250, 0.6);
  background-color: var(--contentBgColor);
  // padding: 10px;
  .btnBox {
    justify-content: flex-end;
  }
}
.add {
  height: 246px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  i {
    font-size: 60px;
    margin-bottom: 15px;
  }
}
.el-date-editor .el-range-separator {
  max-width: 15% !important;
}
.action-header {
  // background-color: var(--mainBgColor);
  .header-div {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -moz-align-items: center;
    -webkit-align-items: center;
    align-items: center;
    .action-title {
      text-indent: 10px;
      -prefix-box-flex: 1;
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
    }
    .action-btn {
      min-width: 60px;
      text-align: right;
      text-indent: 10px;
    }
  }
}
.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cur_pointer {
  cursor: pointer;
}
.status {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 60px solid #1890ff;
  border-right: 60px solid transparent;
}
.statusName {
  color: #fff;
  position: absolute;
  top: 10px;
  left: 0;
  transform: rotate(315deg);
  font-size: 14px;
}
.hoverDiv {
  background-color: #e2e5e7;
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  justify-content: space-around;
  align-content: center;
  align-items: center;
}
#hoverDivItem {
  height: 100%;
  width: 33.3%;
  justify-content: space-around;
  align-content: center;
  align-items: center;
}
.active {
  background-color: #d7d8d9;
}
.btnStyle {
  background: #d7d8d9;
  border: none;
  line-height: 25px;
}
.activeBtn {
  background: #1f292e;
  border: none;
}

</style>
<style type="text/css" lang="scss" scoped>

.mr-18px {
  margin-right: 18px;
}
.width-385px {
  width: 385px !important;
  > /deep/.el-input {
    width: 100% !important;
  }
}
/deep/.el-input.width-385px {
  width: 385px !important;
}
/deep/ .el-button + .el-button {
  margin-left: 3px;
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
/deep/.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
/deep/.el-input-number.is-without-controls .el-input__inner {
  text-align: left;
}
/deep/.custom-card .el-card__body {
  padding: 0 !important;
}

</style>
